export const state = {
  tableData: null,
  typeOfData: null,
};
